<template>
  <div>
    <CompFlex
      v-if="isFilterButtonDisplay"
      align="center"
      justify="flex-end"
      className="mb-4"
    >
      <CompButton
        :label="$t('filter.bo_loc')"
        :min="100"
        :theme="2"
        shape="round-xs"
        color="white"
        @onClick="onMobileFilterDisplay"
      >
        <template v-slot:rightElement
          ><span
            :class="[
              {
                'icon-xmark': isFilterDisplay,
                'icon-filter-v2': !isFilterDisplay,
              },
            ]"
          ></span
        ></template>
      </CompButton>
    </CompFlex>
    <div v-if="isFilterDisplay" class="hab-left-filter">
      <div class="hab-left-filter__show-mobile">
        <CompButton
            :label="$t('filter.close')"
            :min="100"
            :theme="2"
            shape="round-xs"
            color="white"
            @onClick="onMobileFilterDisplay"
        >
          <template v-slot:rightElement
          ><span
              :class="[
              {
                'icon-xmark': isFilterDisplay,
                'icon-filter-v2': !isFilterDisplay,
              },
            ]"
          ></span
          ></template>
        </CompButton>
      </div>
      <div class="hab-left-filter__content">
        <CompFlex
            align="center"
            justify="space-between"
            gap="10"
            className="mb-4"
        >
          <span class="text-14-600">{{ $t("filter.loc") }}</span>
          <span
              class="text-14-400 color-green cursor-pointer"
              v-on:click="onFilterRemove"
            >{{ $t("filter.xoa_loc") }}</span
          >
        </CompFlex>
        <div class="hab-left-filter-block">
          <div>
            <label class="text-14-500 mb-10">{{ $t("filter.gio_di") }}</label>
            <CompFlex align="center" gap="10" wrap="wrap">
              <div class="item" v-for="(time, index) in timeOfDay" :key="index">
                <CompTimeOfDay
                  :dataSource="time"
                  :active="
                    JSON.stringify(time.time) ===
                    JSON.stringify(get(formData, 'times.time', []))
                  "
                  @onChange="(value) => changeField('times', value)"
                />
              </div>
            </CompFlex>
          </div>
          <div class="mt-20">
            <label class="text-14-500 mb-10">{{ $t("filter.nha_xe") }}</label>
            <CompInput @onChange="onSearchCompanies" />
            <div>
              <perfect-scrollbar class="scroll-companie">
                <div
                  v-for="(companie, index) in dataStatisticSearch"
                  :key="index"
                  class="mt-12"
                >
                  <CompCheckbox
                    :label="`${get(companie, 'name', '')} (${get(companie, 'trip_count', 0)})`"
                    :checked="
                      get(formData, 'companies', []).some(
                        (id) => Number(id) === Number(get(companie, 'id', 0))
                      )
                    "
                    @onCheck="
                      (value) => changeField('companies', companie, value)
                    "
                  />
                </div>
              </perfect-scrollbar>
            </div>
          </div>
          <div class="mt-20 pb-20">
            <label class="text-14-500 mb-10">{{ $t("filter.gia_ve") }}</label>
            <CompRange
              :max="2000000"
              :value="get(formData, 'fares', [0, 2000000])"
              :step="200000"
              :tooltipFormatter="
                (v) => `${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
              "
              :marks="{
                0: '0đ',
                2000000: {
                  label: '2.000.000đ',
                  labelStyle: { transform: 'translate(-62px, 0px)' },
                },
              }"
              :height="4"
              tooltip="active"
              @onRange="(value) => changeField('fares', value)"
            />
          </div>
          <div class="mt-20">
            <label class="text-14-500 mb-10">{{ $t("filter.danh_gia") }}</label>
            <div v-for="(rating, index) in ratingData" :key="index">
              <CompCheckbox
                :key="get(formData, 'rating', 0)"
                :checked="Number(get(formData, 'rating', 0)) === Number(get(rating, 'star', 0))"
                @onCheck="() => changeField('rating', get(rating, 'star', 0))"
              >
                <CompFlex align="center" gap="5" wrap="wrap">
                  <CompStarRating
                    :value="get(rating, 'star', 0)"
                    :disabled="true"
                    :starSize="15"
                  />
                  <span>{{ get(rating, 'name', '') }}</span>
                  <span>({{ get(rating, 'value', '') }})</span>
                </CompFlex>
              </CompCheckbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toSearchParams } from "../../../utils/helpers";
import CompFlex from "../../flex/index.vue";
import CompInput from "../../input/index.vue";
import CompCheckbox from "../../checkbox/index.vue";
import CompRange from "../../range/index.vue";
import CompStarRating from "../../star-rating/index.vue";
import CompTimeOfDay from "./time-of-day.vue";
import CompButton from "../../button/index.vue";
import { get } from "lodash"

export default {
  components: {
    CompFlex,
    CompInput,
    CompCheckbox,
    CompRange,
    CompTimeOfDay,
    CompStarRating,
    CompButton,
  },
  props: {
    dataStatistic: {
      type: [Object, Number],
      default: null,
    },
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      isFilterButtonDisplay: false,
      isFilterDisplay: true,
      timeOfDay: [
        {
          case: "SOM",
          name: this.$t("filter.sang_som"),
          time: ["00:00", "06:00"],
        },
        {
          case: "SANG",
          name: this.$t("filter.buoi_sang"),
          time: ["06:01", "12:00"],
        },
        {
          case: "CHIEU",
          name: this.$t("filter.buoi_chieu"),
          time: ["12:01", "18:00"],
        },
        {
          case: "TOI",
          name: this.$t("filter.buoi_toi"),
          time: ["18:01", "23:59"],
        },
      ],
      formData: {},
      dataStatisticSearch: [],
      ratingData: [
        {
          name: this.$t("filter.tro_len"),
          star: 4,
          value: 0,
        },
        {
          name: this.$t("filter.tro_len"),
          star: 3,
          value: 0,
        },
        {
          name: this.$t("filter.tro_len"),
          star: 2,
          value: 0,
        },
        {
          name: this.$t("filter.tro_len"),
          star: 1,
          value: 0,
        },
      ],
      polling: null,
    };
  },
  methods: {
    get,
    handleUrl(searchParams) {
      const newRouter = `${window.location.pathname}?${searchParams}`;
      return window.location.replace(newRouter);
    },
    onSearchCompanies(value) {
      const newSearch = value.toLowerCase();
      this.dataStatisticSearch = this.dataStatistic?.companies?.data?.filter(
        (elm) => elm?.name?.toLowerCase()?.includes(newSearch)
      );
    },
    changeField(name, data, value) {
      let isMultiple = false;
      let newFormData = this.formData;
      let valueSearch = null;
      if (name === "times") {
        newFormData = {
          ...newFormData,
          time: data?.time,
        };
        valueSearch = data?.time;
      } else if (name === "companies") {
        isMultiple = true;
        const newValue = value
          ? [...(newFormData?.companies || []), data?.id]
          : newFormData?.companies?.filter(
              (e) => Number(e) !== Number(data?.id)
            );
        newFormData = {
          ...newFormData,
          companies: newValue,
        };
        valueSearch = newValue;
      } else {
        newFormData = {
          ...newFormData,
          [name]: data,
        };
        valueSearch = data;
      }

      this.formData = newFormData;
      const toSearchParam = toSearchParams(name, valueSearch, isMultiple);
      if (toSearchParam) {
        if (name === "fares" || name === "companies") {
          this.polling = setInterval(() => {
            return this.handleUrl(toSearchParam);
          }, 1000);
        } else {
          return this.handleUrl(toSearchParam);
        }
      }
    },
    onFilterRemove() {
      const removeKey = ["times", "companies", "fares", "rating"];
      const searchParams = new URLSearchParams(window.location?.search);
      removeKey?.forEach((elm) => {
        searchParams.delete(elm);
      });

      return this.handleUrl(searchParams.toString());
    },
    onMobileFilterDisplay() {
      this.isFilterDisplay = !this.isFilterDisplay;

      if (this.isFilterDisplay) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    },
    onResize() {
      this.innerWidth = window.innerWidth;
      if (window.innerWidth <= 992) {
        this.isFilterDisplay = false;
        this.isFilterButtonDisplay = true;
      } else {
        this.isFilterDisplay = true;
        this.isFilterButtonDisplay = false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      if (window.innerWidth <= 992) {
        this.isFilterDisplay = false;
        this.isFilterButtonDisplay = true;
      } else {
        this.isFilterDisplay = true;
        this.isFilterButtonDisplay = false;
      }
    });
    const params = new URLSearchParams(window.location?.search);
    if (this.dataStatistic?.companies) {
      this.dataStatisticSearch = this.dataStatistic?.companies?.data;
    }
    if (this.dataStatistic?.rating?.detail) {
      const newRating = this.dataStatistic?.rating?.detail ?? [];
      this.ratingData = this.ratingData?.map((rating) => ({
        ...rating,
        value: newRating?.reduce(function (prev, next) {
          if (next?.value >= rating?.star) {
            return prev + next?.count;
          }

          return prev;
        }, 0),
      }));
    }
    if (bookingTimes) {
      const bookingTimesArr = bookingTimes.split(",");
      this.formData = {
        ...this.formData,
        times: {
          time: [bookingTimesArr[0], bookingTimesArr[1]],
        },
      };
    }
    if (bookingCompanies) {
      const newP = params.getAll("companies");
      this.formData = {
        ...this.formData,
        companies: newP,
      };
    }
    if (bookingFares) {
      const bookingFaresArr = bookingFares.split(",");
      this.formData = {
        ...this.formData,
        fares: [bookingFaresArr[0], bookingFaresArr[1]],
      };
    }
    if (bookingRating) {
      this.formData = {
        ...this.formData,
        rating: bookingRating,
      };
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" scoped>
.scroll-companie {
  max-height: 300px;
}
</style>
